import React from 'react';
import { Checkbox } from 'antd';
import styles from './CommentOptions.module.scss';

const CommentOptions = ({ availableForClient, setAvailableForClient }) => {
  return (
    <div className={styles.checkBoxesBlock}>
      <Checkbox
        className={styles.checkBox}
        checked={availableForClient}
        onChange={() => setAvailableForClient((prev) => !prev)}
      >
        Показывать собственнику
      </Checkbox>
    </div>
  );
};

export default CommentOptions;
